import { useNavigate } from "react-router-dom";

import ConfirmationQuestion from "../../../components/Questions/ConfirmationQuestion";
import { ABOUT_ROUTES, PATHS } from "../../../config/routeConfig";
import { useVulnerabilityContext } from "../../../context/vulnerability/useVulnerabilityContext";
import { ConfirmationAnswer } from "../../../context/vulnerability/VulnerabilityContext";
import { questionContent } from "../questions";

const AgeCare: React.FC = () => {
  const { answers, setAnswers } = useVulnerabilityContext();
  const navigate = useNavigate();

  const onChange = (answer: ConfirmationAnswer) => {
    setAnswers({
      ...answers,
      ageCare: answer,
    });
  };

  const onContinue = () => {
    navigate(`/${PATHS.About}/${ABOUT_ROUTES.MedicalEquipment}`);
  };

  return (
    <ConfirmationQuestion
      onChange={onChange}
      value={answers.ageCare}
      onContinue={onContinue}
      step={questionContent.ageCare.step}
      title={questionContent.ageCare.title}
      subTitle={questionContent.ageCare.subTitle}
      whyWeWantTexts={questionContent.ageCare.whyWeWantTextsCustomer}
      requireAnswer
    />
  );
};

export default AgeCare;
